function SquareProfile({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '18'} height=${dimensions || '18'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 2V16H2V2H16ZM16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM9 9C7.35 9 6 7.65 6 6C6 4.35 7.35 3 9 3C10.65 3 12 4.35 12 6C12 7.65 10.65 9 9 9ZM9 5C8.45 5 8 5.45 8 6C8 6.55 8.45 7 9 7C9.55 7 10 6.55 10 6C10 5.45 9.55 5 9 5ZM15 15H3V13.47C3 10.97 6.97 9.89 9 9.89C11.03 9.89 15 10.97 15 13.47V15ZM5.31 13H12.69C12 12.44 10.31 11.88 9 11.88C7.69 11.88 5.99 12.44 5.31 13Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default SquareProfile;
